import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.jsx\",\"import\":\"Lato\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"100\",\"300\",\"400\",\"700\",\"900\"],\"style\":[\"normal\",\"italic\"],\"display\":\"swap\",\"preload\":true,\"fallback\":[\"-apple-system\",\"BlinkMacSystemFont\",\"Segoe UI\",\"Roboto\",\"sans-serif\"]}],\"variableName\":\"lato\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/clientComponent.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/store/ReduxProvider.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.css");
